import './AccountDetailsHeader.scss';
import React from 'react';

const AccountRegistration = ({
  accountNumber,
  accountChecksum,
  accountRegistration,
  registrationAddress
}) => (
  <div className="account-registration-modal">
    <div className="header">Registration Details</div>
    <div className="registration">
      <span className="account">Account #</span>
      <span className="blocked_data">
        {accountNumber}-{accountChecksum}
      </span>
    </div>
    <div className="registration-container">
      <div className="registration">Registration</div>
      <div>
        {accountRegistration &&
          accountRegistration.map((info, i) => {
            return (
              <div key={i} className="account-registration-map">
                <span className="registration-info">{info}</span>
                <br />
              </div>
            );
          })}
        {registrationAddress &&
          registrationAddress.map((addressLine, i) => {
            return (
              <div key={i} className="account-registration-map">
                <span className="registration-info">{addressLine}</span>
                <br />
              </div>
            );
          })}
      </div>
    </div>
  </div>
);

export default AccountRegistration;
